module.exports = "/wp-content/plugins/farmacy/assets/js/images/btn-plus-01ed27d7a0062a0928bb6611222ca2bb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-review/cart-item-count-incrementor/img/btn-plus.png
 ** module id = 317
 ** module chunks = 1 9 15 66 78 142
 **/